module.exports = __webpack_public_path__ + "img/user_black.bafa7a71.png";